import "./Print.css";

const Print = ({ children }: { children: React.ReactNode }) => {
  return (
    <div>
      <div className="border-b border-b-gray-900 text-center py-2 bg-gray-200 print:hidden sticky top-0">
        <button
          className="border rounded bg-white py-0.5 px-4 border-neutral-900"
          onClick={() => window.print()}
        >
          Imprimir
        </button>
      </div>

      <div className="w-[670px] m-auto">{children}</div>
    </div>
  );
};

export default Print;
